import DeletePlans from "../dialogs/deletePlans";
import { WfsAccessModal } from "../dialogs/wfsAccessModal";
import {AddRefToPlan} from "../dialogs/addRefToPlan";
import { ShareModal } from "../dialogs/shareModal";
import { InspireModal } from "../dialogs/inspireModal";
import {AddPlanAndFiles} from "../dialogs/addPlanAndFiles";
import ShareMapsLink from "../dialogs/shareMapsLink";
import { NewOrderModal } from "../dialogs/newOrderModal";
import GridTagFilter from "./cardGridTagFilter";
import {useContext, useState} from "react";
import {EntityContext} from "../../context/EntityContext";
import {ListContext} from "../../context/ListContext";
import {CardGridHeaderButton} from "./cardGridHeaderButton";
import {CardGridHeaderSearch } from "./cardGridHeaderSearch";
import {CardGridEmpty } from "./cardGridEmpty";
import {CardDetails } from './cardDetails';
import {CardCounterGroup } from './cardCounterGroup';


export default function CardGrid() {

    const {list,tags, setList, currentSetting} = useContext(ListContext);
    const [openPlanToMapModal, setOpenPlanToMapModal] = useState(false);
    const [currentTag, setCurrentTag] = useState(null);
    const [openPlanAndFilesModal, setPlanAndFilesModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openPlanToOrderModal, setOpenPlanToOrderModal] = useState(false);
    const [openPlanRefModal, setOpenPlanRefModal] = useState(false);
    const [openShareModal, setOpenShareModal] = useState(false);
    const [openInspireModal, setOpenInspireModal] = useState(false);
    const [openWFSAccessModal, setOpenWFSAccessModal] = useState(false);
    const [openShareMapsLink, setOpenShareMapsLink] = useState(false);
    const [openNewOrderModal, setOpenNewOrderModal] = useState(false);
    const [currentEntity, setCurrentEntity] = useState(true);

    return (
        <div className="mx-auto w-full sm:max-w-7xl px-4 sm:px-4 lg:ml-4 lg:max-h-dvh">
            <EntityContext.Provider value={{
                list,
                tags,
                openDeleteModal,
                currentEntity, 
                openShareMapsLink,
                setOpenShareMapsLink, 
                openNewOrderModal,
                setOpenNewOrderModal,
                openPlanToMapModal, 
                setOpenPlanToMapModal,  
                setOpenDeleteModal, 
                currentSetting, 
                setCurrentEntity, 
                setOpenPlanToOrderModal, 
                openPlanToOrderModal,
                openPlanRefModal,
                setOpenPlanRefModal,
                openShareModal,
                setOpenShareModal,
                openInspireModal,
                setOpenInspireModal,
                openWFSAccessModal,
                setOpenWFSAccessModal,
                openPlanAndFilesModal,
                setPlanAndFilesModal,
                currentTag,
                setCurrentTag,
            }}>
                <div className={"text-base items-center mt-8 mb-10 leading-7 text-gray-600"}>
                    <div className="mt-2 sm:flex items-center sm:justify-between">
                        <div className="min-w-0 flex flex-1">
                            <h2 className="w-full text-xl truncate mb-4 Lg:ml-4 sm:mb-0 lg:text-2xl textShadow flex font-normal leading-7 text-gray-600 sm:truncate  sm:tracking-tight gap-2">
                                <p>{`${currentSetting.title}`}</p>
                                {(list?.length > 0  && currentSetting?.limit > 0) ? (
                                    <div className={"flex items-center font-normal"}>
                                        (<span className={(currentSetting?.limit < list?.length) ? "text-red" : ""}>{list?.length}</span> / {currentSetting?.limit})
                                        {(typeof currentSetting?.upgrade !== "undefined") &&  (<a href={currentSetting?.upgrade} className={"ml-2 underline  text-sm"}>Kontigent erhöhen</a>)}
                                    </div>
                                ) : (
                                    <span className="font-normal">
                                        ({list?.length})
                                    </span>
                                )}
                            </h2>
                        </div>

                        <div className="flex flex-shrink-0 justify-end">
                            {(currentSetting?.search?.searchTags === true) && (<CardGridHeaderButton text={"Filtern"} type={'filter'}/>)}

                            {(currentSetting?.search?.searchAllows === true) && (<CardGridHeaderSearch list={list} setList={setList} placeholder={currentSetting?.search?.text}/>)}

                            {(currentSetting?.actions?.planCreation === true) && (<CardGridHeaderButton text={"Plan hochladen"} limit={(list?.length > currentSetting?.limit)} type={'plan'}/>)}

                            {(currentSetting?.actions?.orderCreation === true) && (<CardGridHeaderButton text={"Auftrag erstellen"} limit={(list?.length > currentSetting?.limit)} type={'order'}/>)}

                            {(currentSetting?.actions?.mapCreation === true) && (<CardGridHeaderButton text={"Karte erstellen"} limit={(list?.length > currentSetting?.limit)} type={'map'}/>)}
                        </div>
                    </div>
                </div>

                {(currentSetting?.actions?.orderCounter === true) && (<CardCounterGroup />)}

                <div className={"block sm:flex"}>
                    <div className="flex-grow flow-root">
                        <div className="pb-[100px]">
                            <div className="w-full align-middle mb-8">
                                <div>
                                    {(list?.length > 0 ) ? (
                                        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                                            {list?.map((orders, key) => {
                                                if(typeof currentSetting?.limit !== "undefined" && key > (currentSetting?.limit-1)) {
                                                    return (<CardDetails orders={orders} currentSetting={currentSetting} sBl={true} key={`${orders?.id}-${key}`}/>);
                                                } else {
                                                    return (<CardDetails orders={orders} currentSetting={currentSetting} sBl={false} key={`${orders?.id}-${key}`}/>);
                                                }
                                            })}
                                        </div>
                                    ) : (<CardGridEmpty actions={currentSetting?.actions} dialog={currentSetting?.createDialog}/>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AddPlanAndFiles/>
                <ShareMapsLink/>
                <DeletePlans/>
                <WfsAccessModal/>
                <AddRefToPlan/>
                <ShareModal/>
                <InspireModal/>

                {(currentSetting?.search?.searchTags === true) && (<GridTagFilter/>)}
                {(currentSetting?.actions?.orderCreation === true) && (<NewOrderModal openNewOrderModal={openNewOrderModal} setOpenNewOrderModal={setOpenNewOrderModal} />)}

            </EntityContext.Provider>


        </div>
    )
}
